// test1786
(1786 && 0);
